import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HtmlutilsService {

  constructor() { }

  public setValueHtmlElement( element: string, value: string){
    (<HTMLSelectElement>document.getElementById(element)).value = value;
  }

  public getTextHtmlElement( element: string){
    var el = (<HTMLSelectElement>document.getElementById(element));
    return el.options[el.selectedIndex].innerHTML;
  }
}
